"use client";
import RedHeading from "../../common/common_title/red-heading/RedHeading";
import "./EventSection.css";

export default function EventSection() {
  return (
    <section className="event-section-main">
      {" "}
      <RedHeading title="Industries We Serve" className="top-heading" />
      <div className="event-section">
        <div
          className="bg-image"
          style={{
            backgroundImage: `url("/assets/images/newhome/eventbanner.png" )`,
          }}
        >
          <div className="content-box">
            <h2>Perfect For Every Event</h2>
            <p>
              From high-energy concerts to elegant celebrations, Falcon sfx
              delivers powerful visual effects tailored to every occasion. We
              bring intensity to live shows, create magical moments for weddings
              & grand entries, & add a premium edge to corporate events. Our
              effects elevate the vibe in clubs and DJ nights, & scale
              seamlessly for large festivals & stadium events. No matter the
              size or style of your event, we design effects that captivate
              audiences and leave a lasting impression
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
